import type { ReactNode } from "react";
// eslint-disable-next-line no-restricted-imports
import { Menu as MenuBase } from "@base-ui/react/menu";
import classNames from "classnames";
import type { MenuRootProps } from "./Menu.types";
import styles from "./MenuPopup.module.scss";

export type MenuPopupProps = Pick<
    MenuRootProps,
    "side" | "align" | "sideOffset" | "alignOffset" | "container" | "classNames"
> & {
    children: ReactNode;
};

/**
 * Portal, positioner and popup surface of a menu level. Internal: roots pass
 * their placement through, and the popup scrolls once it reaches the space
 * available on its side.
 */
export const MenuPopup = ({
    children,
    side,
    align,
    sideOffset,
    alignOffset,
    container,
    classNames: slotClassNames,
}: MenuPopupProps) => (
    <MenuBase.Portal container={container}>
        <MenuBase.Positioner
            side={side}
            align={align}
            sideOffset={sideOffset}
            alignOffset={alignOffset}
            className={classNames(
                styles.positioner,
                slotClassNames?.positioner,
            )}
        >
            <MenuBase.Popup
                className={classNames(styles.popup, slotClassNames?.popup)}
            >
                {children}
            </MenuBase.Popup>
        </MenuBase.Positioner>
    </MenuBase.Portal>
);
